<dt-modal-content (closeClick)="dialogRef.close()" [contentPadding]="false">
  <ng-template #title i18n>Vorschau des Fragebogens</ng-template>
  <ng-template #content>
    @if (questionnaire.length > 0) {
      <dt-questionnaire [questionnairePages]="questionnaire"></dt-questionnaire>
    } @else {
      <div class="empty-placeholder" i18n>Der Fragebogen ist leer.</div>
    }
  </ng-template>
</dt-modal-content>
